<script>
import VueCharts from 'vue-chartjs'
import ChartMixin from '@/views/Dashboard/ChartMixin'

export default {
    name: 'LatencyChart',
    extends: VueCharts.Bar,
    mixins: [ChartMixin],
    methods: {
        updateChart () {
            if (!this.timeRange) {
                return
            }
            this.generateLabels()
            // fill in data
            const data = {
                label: this.$filters.capitalize(this.$t('medianLatency')),
                backgroundColor: '#8484ff',
                data: []
            }
            data.data[this.labelList.length - 1] = 0
            for (let item of this.data) {
                data.data[this.mapLabelToIndex[item.datetime]] = item.median_latency
            }
            // render
            this.renderChart({ labels: this.displayLabelList, datasets: [data] }, this.options)
        }
    }
}
</script>
